<div
  class="rec"
  [class.rec--single-layer]="singleLayer"
  [class.rec--recording]="recording"
  [class.rec--playback]="playback"
  [class.rec--no-record]="noRecord"
  #element
>
  <app-meta
    title="Voice recorder online, record sound or voice from a microphone"
    description="Record sound from your microphone, overwrite bad stuff and download it to your computer in the form of an audio MP3 file"
    keywords="dictaphone, online dictaphone, voice recorder, online voice recorder, voice recording program, recording of the sound"
    i18n-title
    i18n-description
    i18n-keywords
  ></app-meta>

  <div class="rec__content">
    <div class="container">
      <app-timeline></app-timeline>
      <app-timeline-block></app-timeline-block>
      <app-record-buttons></app-record-buttons>
      <app-timer></app-timer>
    </div>
  </div>

  <div class="rec__toolbar hide-on-recording hide-on-no-record">
    <div class="container">
      <app-toolbar></app-toolbar>
    </div>
  </div>

  <app-modal [closeOnBackgroundClick]="false">
    <app-share-link-modal [recordUrl]="recordUrl" *ngIf="recordUrl"></app-share-link-modal>
  </app-modal>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/rec.component.html